<template>
    <div class="emptyBox">
        <div class="box">
            <i class="icon icon_empty"></i>
            暂无相关数据！
        </div>
    </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'empty',
    data() {
        return {}
    },
    created(){},
    methods: {},
    mounted() {}
  }
</script>

<style lang="scss" >
    .emptyBox{
        height:100%;
        .box{
            text-align: center;
            height: 200px;
            line-height: 200px;
            font-size: 16px;
            color: #999;
            padding-top: 30px;
            .icon_empty{
                display: inline-block;
                width: 200px;
                height: 200px;
                background: url('../../assets/noData.png') no-repeat;
                background-size: cover;
                margin-right: 15px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/productInfoComponents/dataEmpty.vue